import Result from "slotworks/model/gameplay/records/results/result";

export default class BonusResult extends Result {
    public readonly id: string;
    public played: boolean;

    constructor(id: string, played: boolean = false) {
        super();

        this.id = id;
        this.played = played;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/model/gameplay/records/results/bonus-result.ts